import React, { Component } from 'react';

class Auth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {}
        }
    }

    componentDidMount() {
        try {
            const user = JSON.parse(sessionStorage.getItem('user'));
            this.setState({
                user
            });
        } catch (error) {
            console.error(error);
            this.setState({
                user: {}
            });
        }
    }

    // 获取深度嵌套json
    getJson = (arr = [], obj = {}) => {
        return arr.reduce((a, b) => a && a[b] ? a[b] : '', obj);
    }

    render() {
        const user = this.state.user;
        // 判断是否有管理员权限
        if (!this.getJson(['email'], user) == 'admin') {
            return null
        }
        return this.props.children;
    }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/components/compared/Auth.js